import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTrigger,
} from "@/components/ui/dialog";
import { DialogTitle } from "@radix-ui/react-dialog";
import { Channel } from "types";

export const DescriptionReveal = ({ children, channel }: { children: React.ReactNode, channel: Channel }) => {
    return (
        <Dialog>
            <DialogTrigger asChild>{children}</DialogTrigger>
            <DialogContent
                className="bg-brand-dark text-white border-0 max-w-96 sm:max-w-[730px] max-h-[80vh] break-words text-wrap   "    
            >
                <DialogHeader className="text-center items-center text-wrap">
                    <div className="flex flex-col space-y-4 w-full py-2 text-wrap">
                        <DialogTitle className="font-light">{channel.name}'s Description</DialogTitle>
                        <div className="flex flex-col gap-2 text-wrap max-w-[330px] sm:max-w-2xl">
                            <p className="text-gray-300">{channel.description}</p>
                        </div>
                    </div>
                </DialogHeader>
            </DialogContent>
        </Dialog>
    );
}
